import React from 'react';

import RemovePost from '@src/api/RemovePost';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';

const useRemove = () => {
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();

  const handleRemove = React.useCallback(
    async (id: string) => {
      try {
        await RemovePost(id, accessToken, axiosRequestConfig);
      } catch (error) {
        console.log('[Error:useRemove]', error);
        axiosErrorHandler(error);
      }
    },
    [accessToken, axiosErrorHandler, axiosRequestConfig]
  );
  return React.useMemo(() => ({ handleRemove }), [handleRemove]);
};

export default useRemove;
